import { setDoc, doc } from "firebase/firestore";
import { db } from "../services/firebase";

export const handleGenerateContent = async (data, grade, week) => {
  const content = setDoc(
    doc(db, "Lesson", `Grade${grade}`, "week", `week${week}`),
    {
      Lesson: data,
    }
  );

  return content;
};

export const handleGenerateQuiz = async (data, grade, week) => {
  const content = setDoc(
    doc(db, "Quiz", `Grade${grade}`, "week", `week${week}`),
    {
      Quiz: data,
    }
  );
  return content;
};

export const handleGenerateUsers = async (number, userName, grade) => {
  for (let i = 1; i <= number; i++) {
    // const username = `${userName}${grade}-0${2}@test.com`;
    const username = `${userName}${grade}-0${4}@test.com`;
    await setDoc(doc(db, "Users", username), {
      character: 1,
      grade: grade,
      username: username,
      completeWeek: [
        { grade: 4, week: 1 },
        { grade: 5, week: 5 },
        { grade: 6, week: 1 },
      ],
    });
  }
  // return addField;
};
